import { Component, Input } from '@angular/core';
import { NgIf, NgFor } from '@angular/common';
import { MarkedPipe } from '../../pipes/marked.pipe';

@Component({
    selector: 'app-tabs-slice',
    templateUrl: './tabs-slice.component.html',
    styleUrls: ['./tabs-slice.component.scss'],
    imports: [
        NgIf,
        NgFor,
        MarkedPipe,
    ],
})
export class TabsSliceComponent {
  @Input()
  public slice!: any;

  public currentTab = 0;
}
